<template>
    <div>
        <!-- <div style="margin-top: 12px; border: 2px solid #ddd; padding: 12px; border-radius: 10px; position: relative;">
            <span style="display: inline-block; font-weight: 600; font-size: 11px; position: absolute; padding: 0 5px; background: #fff; color: #777; top: -9px;">{{ $t("settings.preview") }}:</span>
            <div style="display: flex; align-items: center; margin-top: 5px; opacity: .8;">
                <div style="text-align: center; padding-right: 12px; padding-left: 4px;">
                    <i aria-hidden="true" class="v-icon material-icons theme--light" style="color: rgba(0,0,0,.7); transition: all 0.3s ease 0s; margin: 0px; transform: rotate(0deg);">circle_slice_half</i>
                    <br>
                    <span style="white-space: nowrap; font-size: 11px;">16-26</span>
                </div>
                <div style="flex-grow: 1; text-align: left; font-size: 11px; padding-left: 0px; border-left: 0px solid #ddd; ">
                    <b style="padding-bottom: 4px; display: block; font-size: 13px; font-weight: 600;">{{ title }}</b>

                    <div v-if="primaryStep" style="padding: 4px 0; border-top: 1px solid rgba(0,0,0,.08); display: flex;">
                        <span style="flex-grow: 1; margin-right: 10px;">
                            <template v-if="secondaryStep">
                                <span v-text="primaryStep.tooth_id ? primaryStep.tooth_id.length : primaryStep.tooth_id_upper.length" /> {{ $t('plan_calculator.state_' + primaryStep.state) }}:
                            </template>
                            {{ protocol.variation_titles[0][this.$store.state.language] }}
                        </span>
                        <pm-price :value="protocol.variation_prices[0][this.$store.state.currency]" :currency="this.$store.state.currency" />
                    </div>

                    <div v-if="secondaryStep" style="padding: 4px 0; border-top: 1px solid rgba(0,0,0,.08); display: flex;">
                        <span style="flex-grow: 1; margin-right: 10px;">{{ secondaryStep.tooth_id.length }} {{ $t('plan_calculator.state_' + secondaryStep.state) }}: {{ bridgeOptions[0].title[this.$store.state.language] }}</span>
                        <pm-price :value="bridgeOptions[0].price[this.$store.state.currency] * secondaryStep.tooth_id.length" :currency="this.$store.state.currency" />
                    </div>
                </div>
            </div>
        </div> -->
        <div style="margin: 20px 0 12px 0; text-align: left; font-size: 11px; text-align: center;">
            <span style="color: #1565c0; font-weight: 600; border: 2px solid #1565c0!important; border-radius: 16px; padding: 2px 10px; font-size: 14px; text-transform: none; display: inline-block; margin-top: 0px;" @click="$bus.$emit('pricelist:previewAnimation', protocolName)">
                <mdi size="18">mdiPlay</mdi>{{ $t("settings.3d_preview") }}
            </span>
        </div>

    </div>
</template>
<script>
export default {
    props: [
        "protocolName",
    ],
    data() {
        return {
            primaryOption: 0,
        };
    },
    computed: {
        title() {
            return this.$t("plan_simple.template_" + this.$store.state.localSettings.protocols[this.protocolName].title);
        },
        protocol() {
            return this.getProtocol();
        },
        primaryStep() {
            const protocol = this.getProtocol();

            for (const i in protocol.steps) {
                const step = protocol.steps[i];
                if (parseInt(step.state) === parseInt(protocol.variations_by) && parseInt(step.active) === 1) {

                    return step;
                }
            }

            return null;
        },
        secondaryStep() {
            const protocol = this.getProtocol();

            if (parseInt(protocol.variations_by) === 15) return null;

            for (const i in protocol.steps) {
                const step = protocol.steps[i];
                if (parseInt(step.state) === 15 && parseInt(step.active) === 1 && (typeof step.forced_price === "undefined" || parseInt(step.forced_price) === 0) && !step.disable_options) return step;
            }

            return null;
        },
        bridgeOptions() {
            const options = this.getBridgeOptions();
            return options.filter((opt) => {
                return parseInt(opt.status) === 1;
            });
        },
    },
    methods: {
        getProtocol() {
            return this.$store.state.localSettings.protocols[this.protocolName];
        },
        getBridgeOptions() {
            if (typeof this.$store.state.cache.priceListBridgeOptions !== "undefined") return this.$store.state.cache.priceListBridgeOptions;
            const options = [];
            Object.keys(this.$store.state.dentalStates).forEach((stateId) => {
                const state = this.$store.state.localSettings.dentalStates[stateId];
                if (parseInt(state.parent_id) === 15 && !state.hidden) options.push(state);
            });
            return options;
        },

    },
};
</script>
